import React from 'react';
import { connect } from "react-redux";

class Client extends React.Component {
  
    state={
        naziv: '',
        oib: '',
        adresa: '',
        email: '',
        telefon: '',
        pdv: true,
        fiskCert: '',
        certPass: '',
        selectedFile: null
    }

    componentDidMount(){     
    }

    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    submitHandler = async e => {
        e.preventDefault()
        //console.log("CHANGE")   
    }

    

    render(){   
    return (
        <form style={{padding: "40px"}}>
            <div className="form-group row">
                <label htmlFor="clientName" className="col-sm-2 col-form-label">Klijent</label>
                <div className="col-sm-4">
                    <input
                            disabled
                            type="text"
                            value={this.props.credentials.clientName}
                            onChange={e => this.handleChange()}
                        />
                </div>
            </div>
            <div className="form-group row">
                <label htmlFor="OIB" className="col-sm-2 col-form-label">OIB</label>
                <div className="col-sm-4">
                    <input
                        disabled 
                        type="text"
                        value={this.props.credentials.clientCountrySpecificVatNumber}
                        onChange={e => this.handleChange()}
                    />
                </div>
            </div>
            <div className="form-group row">
                <label htmlFor="Adresa" className="col-sm-2 col-form-label">Adresa</label>
                <div className="col-sm-4">
                    <input  
                        disabled                       
                        type="text"
                        value={this.props.credentials.clientFullAddress}
                        onChange={e => this.handleChange()}
                    />
                </div>
            </div>
            <div className="form-group row">
                <label htmlFor="PosBr" className="col-sm-2 col-form-label">Email</label>
                <div className="col-sm-4">
                    <input     
                        disabled                    
                        type="text"
                        value={this.props.credentials.contactEmail}
                        onChange={e => this.handleChange()}
                    />
                </div>
            </div>
            <div className="form-group row">
                <label htmlFor="PosBr" className="col-sm-2 col-form-label">Telefon</label>
                <div className="col-sm-4">
                    <input 
                        disabled                        
                        type="text"
                        value={this.props.credentials.contactPhoneNumber}
                        onChange={e => this.handleChange()}
                    />
                </div>
            </div>
            <div className="form-group row">
                <label htmlFor="pdv" className="col-sm-2 col-form-label">PDV</label>
                <div className="col-sm-10">
                <label className="form-check-label" htmlFor="gridCheck2">
                    <input  
                        disabled                       
                        type="checkbox"
                        checked={this.props.credentials.inVatSystem}
                        //onChange={e => handlePdv()}
                    />
                    
                      &nbsp;&nbsp; u sustavu pdv-a
                    </label>
                
                </div>
            </div>            
            {/*}
            <div className="form-group row justify-content-md-center">
                <div className="col-sm-2">
                    <button                          
                        className="btn btn-info" 
                        style={{padding:"10px"}} 
                        onClick={e => this.submitHandler(e)}
                    >
                        Save
                    </button>
                </div>
            </div>
            */}

            
            
        </form>
    )
}
}
const mapStateToProps = state => {
    return {
        credentials: state.user.credentials
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Client);


